import React, { useContext } from 'react'

import { ButtonV2, Column, Icon, Row, Text } from '@vividseats/vivid-ui-kit'
import get from 'lodash/get'

import productionDetailsContext from '@/context/production-details'

import style from './styles.module.scss'

const TicketsResponseError: React.FC = () => {
    const { state: productionState } = useContext(productionDetailsContext)

    const categoryName = get(productionState, 'data.performers.0.category.name')
    const subcategoryName = get(productionState, 'data.performers.0.category.subCategories.0.name')

    return (
        <Row
            justify="center-vertical"
            align="stretch"
            className={style.ticketsResponseErrorRow}
            data-testid="tickets-response-error"
        >
            <Column mb={1.5} noFlex>
                <Icon size="lg" type="ticket" rounded muted />
            </Column>
            <Column noFlex>
                <Text size="body" weight="bold">
                    Sorry, there was an error
                </Text>
            </Column>
            <Column mt={0.4375} mb={2} noFlex>
                <Text size="body">Try again in a few minutes</Text>
            </Column>
            <Row justify="center-vertical" align="stretch">
                {categoryName && (
                    <Column mb={1} noFlex>
                        <ButtonV2
                            block
                            size="large"
                            importance="tertiary"
                            href={get(productionState, 'data.performers.0.category.organicUrl')}
                        >
                            {categoryName} Tickets
                        </ButtonV2>
                    </Column>
                )}
                {subcategoryName && (
                    <Column noFlex>
                        <ButtonV2
                            size="large"
                            block
                            importance="tertiary"
                            href={get(productionState, 'data.performers.0.category.subCategories.0.organicUrl')}
                        >
                            {subcategoryName} Tickets
                        </ButtonV2>
                    </Column>
                )}
            </Row>
        </Row>
    )
}

export default TicketsResponseError
